import { useCallback, useMemo, useState } from "react";

const DEFAULT_PAGE_SIZE = 10;

export function useBillingClientPagination<T>(rows: T[]) {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const pageRows = useMemo(() => {
    const start = pageIndex * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, pageIndex, pageSize]);

  const handlePageChange = useCallback(
    (newPageIndex: number, newPageSize: number) => {
      setPageIndex(newPageIndex);
      setPageSize(newPageSize);
    },
    [],
  );

  const resetToFirstPage = useCallback(() => setPageIndex(0), []);

  return {
    pageIndex,
    pageSize,
    pageRows,
    handlePageChange,
    resetToFirstPage,
  };
}
